import React from "react";

const ActionButtons = ({ onAccept, onReject }) => {
  return (
    <div className="widget-news-footer two-column">
      <div
        onClick={onAccept}
        style={{ cursor: "pointer" }}
        title="Accept Connect Invitation"
      >
        <strong>Accept</strong>
      </div>
      <div
        onClick={onReject}
        style={{ cursor: "pointer" }}
        title="Reject Connect Invitation"
      >
        <strong>Reject</strong>
      </div>
    </div>
  );
};

export default ActionButtons;



// WEBPACK FOOTER //
// ./src/_components/UI/UserWidget/ActionButtons/index.js